<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        結果履歴
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">結果履歴</a>
          </li>
      </ul>
    </div>
    <!-- <b-card> -->
      <!-- <template slot="header"><i class='fa fa-align-justify'></i>結果履歴</template> -->
      <!-- detail search start -->
      <!--
        詳細点検内容
        1. 点検開始時間 - 適用済み
        2. 点検終了時間 - 適用済み
        3. 点検総時間
        4. 検出の有無 - 適用済み
        5. エラーの有無 - 適用済み
        6. ページの有無 - ?
       -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> 検査日
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1日</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1週</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1月</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">週</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">月</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> 完了日
                <b-button size="sm" variant="info" @click="set_sd('', 'finished_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'finished_at')">-1日</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'finished_at')">-1週</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'finished_at')">-1月</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'finished_at')">週</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'finished_at')">月</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.finished_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.finished_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">エラー</label><br>
              <c-switch v-if="so.adv" v-model="so.opt.error_count" @change="($event) = so.opt = Object.assign({}, so.opt, { error_count : $event }); refresh()"  color="warning" label variant="pill" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">検出</label><br>
              <c-switch v-if="so.adv" v-model="so.opt.detect_count" @change="($event) = so.opt = Object.assign({}, so.opt, { detect_count : $event }); refresh()"  color="danger" label variant="pill" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">一致タイプ</label>
            <b-form-group>
              <b-form-radio-group v-model="so.opt.match_type" @change="($event) = so.opt = Object.assign({}, so.opt, { match_type : $event })" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:すべて一致</b-form-radio>
                <b-form-radio value="or">[OR]:最低でも1つは一致</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button class="btn-add" size="sm" variant="success" @click="refresh"> 検索 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> リセット </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 閉じる </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <b-card>
        <b-row>
          <b-col md="5">
            <span class="text-center" v-b-tooltip.hover title="リアルタイムでログを確認できる">
              Show Count
              <select v-model="so.perPage" @change="refresh">
                <option value="15">デフォルト 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>
            </span>
          </b-col>
          <b-col sm="5">
            <!-- 여기서 고민되는 부분이 점검 결과에서 어떠한 페이지를 검색 할 것인가임 -->
            <!--
              私がもしユーザーだったらチェックしたい部分
              1. 点検に失敗した部分や検出された場合
              2. 特定のページ範囲
            -->
            <b-input-group size="sm" class="pr-3">
              <b-input-group-append>
                <label class="mr-3" for="opt_detect">クイック検索</label>
              </b-input-group-append>
              <b-input-group-append>
                <label class="mr-3" for="opt_detect">検出</label>
                <c-switch class="mr-3" :disabled="so.adv"  color="danger" label variant="pill" @change="($event) => { if(loading) { return; } so.sv = $event; so.sk = 'detect_count'; refresh() }" />
              </b-input-group-append>

              <b-input-group-append>
                <label class="mr-3" for="opt_error">エラー</label>
                <c-switch class="mr-3" :disabled="so.adv"  color="warning" label variant="pill" @change="($event) => { if(loading) { return; } so.sv = $event; so.sk = 'error_count'; refresh() }"  />
              </b-input-group-append>
            </b-input-group>

          </b-col>
          <b-col sm="1">
            <b-btn block variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
          </b-col>
          <b-col sm="1">
            <b-btn block variant="outline-secondary" @click="search_opt">
              <i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 詳細検索</i>
            </b-btn>
          </b-col>
        </b-row>
        <hr>

        * <b-badge variant="success">ログイン成功 </b-badge> or <b-badge variant="warning">ログイン失敗 </b-badge>
        : ログインページからログイン後、401 Unauthorizedまたは403 Forbesidenでなければ成功として記録されます
        <br>
        * <b-badge variant="primary">チケット </b-badge>
        : FQDNを押すことでチケットをコピーすることができます。サイトに問題がある場合、迅速に処理するためにチケットで連絡する必要があります
        <br>
        * <b-badge variant="info">ログイン中 </b-badge>
        : ログイン設定を使用するかどうかを表示します
        <br>
        * <b-badge variant="info">JSイベント </b-badge>
        : リンクをクリックすると、JavaScriptのクリックイベントが発生します（イベント発生の役割を果たすダイナミックスクリプトを実行することができます）
        <br>
        * <b-badge variant="success">安全 </b-badge>
        : 悪意のあるコードの配布やウェイポイントの検出はありません
        <br>
        * <b-badge variant="danger">検出 </b-badge>
        : 検出された悪意のあるコードの配布とウェイポイントがあります
        <br>
        * <b-badge variant="warning">エラー</b-badge>
        : ページの読み込みが正常に行われなかった場合です。ページの応答状況 : <a target="_blank" href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes">400 ~ 500</a>
        <br>
        * <b-badge variant="dark">検査失敗</b-badge>
        : チェックの1ページ目からチェックができない、またはシステムに問題があります
        <br>
        * <b-badge variant="primary">検査中</b-badge>
        : 検査中のリアルタイムの状況を確認することができます
        <br>
        <small>(検査が処理されないと表示されることがあり、この場合、一定時間後に検査失敗として分類されます) </small>
        <hr>
        <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="fqdn" slot-scope="row">
            <b-img @click="copy(row.item.task_key, site.fqdn)" style="display: inline-block; cursor: pointer;" v-bind="{ width: 15, height: 15 }"  src="ico/copy.ico" alt=""></b-img>
            <b-button variant="link"  style="display: inline-block" :href="'http://'+site.fqdn" target="_blank">
              {{site.fqdn}}
              <b-img src="img/goto_site.png" alt="new Site" v-bind="{ width: 12, height: 12 }"></b-img>
            </b-button>
          </template>
          <template slot="count" slot-scope="row">
            {{ row.item.page_count | number }} ({{ ((row.item.page_count - row.item.ext_count) || 0) | number }} / {{(row.item.ext_count || 0) | number}} / {{(row.item.resource_count || 0)  | number}})
          </template>
          <template slot="created_at" slot-scope="row">
          <!-- 이 부분 데이터 넣는 것 확인 필요 -->
            {{row.item.started_at | datetime}} ~ {{row.item.finished_at | datetime}}
          </template>
          <template slot="status" slot-scope="row">

            <b-badge v-if="row.item.detect_count > 0" variant="danger">Detect <b-badge variant="light">{{ row.item.detect_count | number }}</b-badge></b-badge>
            <b-badge v-else-if="row.item.finished_at && row.item.page_count < 1" variant="dark">Inspection Failed</b-badge>
            <b-badge v-else-if="!row.item.finished_at" variant="info">検査中 </b-badge>
            <b-badge v-else variant="success">安全 </b-badge>

            <b-badge v-if="row.item.error_count > 0" variant="warning">エラー <b-badge variant="light">{{row.item.error_count | number}}</b-badge></b-badge>

            <!-- 400 ~ 500 -->
            <!-- 에러에 대한 추가 설명 필요 -->
          </template>
          <template slot="func" slot-scope="row">
            <b-btn v-if="!row.item.finished_at" @click="sync.task_key = row.item.task_key; timer()"  size="sm" variant="primary">
              <span v-if="sync.status && row.item.task_key == sel_status.task_key" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">&nbsp;</span>
              検査中
            </b-btn>
            <b-btn v-else @click="detail(row.item.id)" size="sm" variant="outline-primary">詳細</b-btn>
            <b-btn v-if="!row.item.finished_at" @click="scan_stop(row.item.task_key)"  size="sm" variant="warning">ストップ</b-btn>
          </template>
        </b-table>
        <hr>

        <b-row>
          <b-col md="5">
          </b-col>
          <b-col md="3">
            <b-pagination class="pull-left" size="sm" :total-rows="getRowCount" :per-page="so.perPage" v-model="currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-col md="4">
            <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
            <!-- <b-button v-if="sel_status && sel_status.task_key" size="sm" class="float-right text-white mr-2" variant="info" @click="sync.status = !sync.status"> Auto Refresh ({{sync.timer}}) </b-button> -->
          </b-col>
        </b-row>
        <!-- 사이트 점검 정보 -->
      </b-card>
      <!-- 여기서 상세 내용  보여 줘야 함 -->
      <hr v-if="sel_result && sel_result.id && $route.params.site_id">
      <detail v-if="sel_result && sel_result.id && $route.params.site_id" :result_id="sel_result.id" :item="{ fqdn : site.fqdn }"></detail>
      <status v-if="sel_status && sel_status.task_key" :status="sel_status" :refresh_timer="sync.timer" @stop="sync.status = !sync.status"/>
    <!-- </b-card> -->
    <!-- <hr>
    <router-view @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
